import PropTypes from 'prop-types'
import Slider from 'react-slick/lib/slider'
import ImageFallback from 'Components/imagefallback/next_image'
import { arrayCheck } from 'Helpers/arrayCheck'

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  useTransform: false,
  centerMode: true,
  variableWidth: true,
  centerPadding: '0px',
}

const MaleDailyVideo = ({ videos, isMobile }) => {
  const device = isMobile ? 'mobile' : 'desktop'

  if (!arrayCheck(videos?.data)) return null

  return (
    <>
      <div className={`maledaily-video maledaily-video--${device}`}>
        <p
          className={`maledaily-video__title maledaily-video__title--${device}`}
        >
          <span className={isMobile ? 'fd-heading-4' : 'fd-heading-2'}>
            Videos For You
          </span>
        </p>
        <div className="maledaily-video__slider">
          {arrayCheck(videos?.data) && (
            <Slider {...settings}>
              {videos?.data?.map((video) => (
                <div
                  key={video.id}
                  className={`maledaily-video__video-item maledaily-video__video-item--${device}`}
                  style={{ width: isMobile ? 300 : 618, height: 'auto' }}
                >
                  <div
                    className={`maledaily-video__item maledaily-video__item--${device}`}
                  >
                    <a
                      href={video?.link || '#'}
                      draggable={false}
                      className="maledaily-video__link"
                    >
                      <div className={`maledaily-video__thumbnail maledaily-video__thumbnail--${device}`}>
                        <ImageFallback
                          objectFit="cover"
                          alt={video?.title}
                          src={
                            video?.thumbnail?.replace(
                              /0.jpg/g,
                              'maxresdefault.jpg',
                            ) || process.env.NEXT_PUBLIC_S3_IMAGE_EMPTY_3_1
                          }
                          fallbackSrc={process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN_3_1}
                          width={800}
                          height={450}
                          quality={100}
                          draggable={false}
                        />
                        <div className="maledaily-video__play">
                          <img
                            src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-home/fd-button-play.svg"
                            alt="btn-play"
                            width={48}
                            height={48}
                            draggable="false"
                          />
                        </div>
                        <div className="maledaily-video__video-overlay" />
                      </div>
                    </a>
                    <div
                      className={`maledaily-video__title-box maledaily-video__title-box--${device}`}
                    >
                      <div
                        className={`maledaily-video__video-title-wrapper ${
                          isMobile ? 'fd-heading-4' : 'fd-heading-3'
                        }`}
                      >
                        <p className="maledaily-video__video-title">
                          {video?.title || '-'}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          )}
        </div>
      </div>

      <style jsx>
        {`
          .maledaily-video {
            width: 100%;
            margin: auto;
            background-image: url('/images/male_daily_rectangle.svg');
            background-size: 100% 100%;
            padding: var(--space-48) var(--space-0) var(--space-80) var(--space-0);
          }

          .maledaily-video--mobile {
            background-image: none;
            padding: var(--space-0);
          }

          .maledaily-video__slider {
            width: 100%;
          }

          .maledaily-video__title {
            text-align: center;
            margin-top: var(--space-0);
            margin-bottom: var(--space-40);
            color: #fff;
          }

          .maledaily-video__title--mobile {
            margin-bottom: var(--space-20);
          }

          .maledaily-video__video-title-wrapper {
            background-color: #0032b1;
            padding: var(--space-20);
          }

          .maledaily-video__video-title {
            color: var(--text-default-inverse);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            word-break: break-word;
            margin: var(--space-0);
          }

          .maledaily-video__title-box {
            height: auto;
            min-height: 168px;
            text-align: center;
            opacity: 0;
            transition: opacity 0.3s;
          }

          .maledaily-video__item {
            width: 100%;
            max-width: 617px;
            display: flex;
            flex-direction: column;
          }

          .maledaily-video__item--mobile {
            width: 300px;
          }

          .maledaily-video__video-item {
            position: relative;
          }

          .maledaily-video__video-overlay {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 1;
            background-color: rgb(0, 0, 0, 0.75);
          }

          .maledaily-video__thumbnail {
            height: 100%;
            max-height: 347px;
            width: auto;
            aspect-ratio: 16/9;
            position: relative;
            user-select: none;
            -moz-user-select: -moz-none;
            -webkit-user-drag: none;
            pointer-events: none;
          }

          .maledaily-video__thumbnail--mobile {
            max-height: 168px;
          }

          .maledaily-video__play {
            position: absolute;
            top: 50%;
            left: 50%;
            right: 50%;
            bottom: 50%;
            align-items: center;
            justify-content: center;
            display: none;
          }
        `}
      </style>

      <style jsx global>
        {`
          .maledaily-video .slick-slide {
            padding: 0px var(--space-20);
          }

          .maledaily-video--mobile .slick-slide {
            padding: 0px var(--space-4);
          }

          .maledaily-video .slick-dots {
            text-align: center;
            color: #fff;
            bottom: -32px;
          }

          .maledaily-video--mobile .slick-dots {
            bottom: 0px;
          }

          .maledaily-video .slick-dots li {
            width: 8px;
            height: 8px;
            position: relative;
            transition: margin 0.2s ease-out;
          }
          .maledaily-video .slick-dots li.slick-active {
            margin: 0 var(--space-12) !important;
          }
          .maledaily-video .slick-dots li.slick-active:nth-child(1) {
            margin-left: 0;
          }
          .maledaily-video .slick-dots li.slick-active:nth-last-child(1) {
            margin-right: 0;
          }
          .maledaily-video .slick-dots li button {
            width: 24px;
            height: 8px;
            position: relative;
            padding: 0;
          }
          .maledaily-video .slick-dots li button:before {
            content: close-quote;
            background-color: #fff;
            opacity: 0.3;
            transition: all 0.2s ease;
            border-radius: 50%;
            width: 8px;
            height: 8px;
            left: 50%;
            transform: translateX(-50%);
          }
          .maledaily-video .slick-dots li.slick-active button {
            width: 24px;
          }
          .maledaily-video .slick-dots li.slick-active button:before {
            width: 24px;
            opacity: 1;
            border-radius: 4px;
            background-color: #fff;
          }

          .maledaily-video .slick-center .maledaily-video__title-box {
            opacity: 1;
          }

          .maledaily-video .slick-center .maledaily-video__video-overlay {
            opacity: 0;
            transition: opacity 0.3s;
            z-index: 0;
          }

          .maledaily-video .slick-center .maledaily-video__play {
            display: flex;
          }

          .maledaily-video .slick-slide .maledaily-video__link {
            pointer-events: none;
          }

          .maledaily-video .slick-center .maledaily-video__link {
            pointer-events: all;
          }
        `}
      </style>
    </>
  )
}

MaleDailyVideo.propTypes = {
  isMobile: PropTypes.bool,
  videos: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
}

export default MaleDailyVideo
